<template>
    <div class="edit-workList">
        <div class="form-button">
            <el-button type="primary" v-if="sort!==2" @click="dialog.back.methods.open()">关闭工单</el-button>
        </div>
        <div class="container">
            <div class="form">
                <mc-layout-row label-text="站点SN" :labelWidth="170">
                    <mc-label info>{{assignDate.site_sn}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="站点名" :labelWidth="170">
                    <mc-label info>{{assignDate.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="告警内容" :labelWidth="170">
                    <mc-label info>{{assignDate.alert_content}}</mc-label>
                </mc-layout-row>

                <div class="line"></div>

                <mc-layout-row label-text="工单编号" :labelWidth="170">
                    <mc-label info>{{id}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="工单标题" :labelWidth="170" important>
                    <el-input v-model="assignDate.name" :disabled="true" placeholder="请输入工单标题"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="事件类型" :labelWidth="170" important>
                    <el-select style="width:100%" v-model="assignDate.problem_type" :disabled="true" placeholder='请选择事件类型'>
                        <el-option v-for='item in formData.methodType' :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="工单类型" :labelWidth="170" important>
                    <el-select style="width:100%" v-model="assignDate.server_type" :disabled="true" placeholder='请选择工单类型'>
                        <el-option v-for='item in formData.listType' :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>

                <div class="line"></div>

                <!-- <mc-layout-row label-text="工单记录" :labelWidth="170" align-column="top">
                    <el-input type="textarea" v-model="formData.formRecord" rows='3' placeholder="请输入备注"></el-input>
                </mc-layout-row> -->
                <!-- <mc-layout-row label-text="已有的附件" :labelWidth="170">
                    <div class="select-item" v-for="(item,index) of seleceItem" :key="index" @click="$_downLoadFile(item.id)">
                        <span>{{item.name}}</span>
                    </div>
                </mc-layout-row> -->
                <mc-layout-row label-text="已有的附件" :label-width="170" v-if="!seleceItem.length"><mc-label info></mc-label></mc-layout-row>
                <mc-layout-row label-text="已有的附件" :labelWidth="170" align-column="top" :label-show='!index' v-for="(item,index) of seleceItem" :key="index" content-align-row="right">
                    <div style="width:515px;">
                        <mc-label info style="position:relative;" class="upload-item" icon="el-icon-document">
                            <span>{{ item.name }}</span>
                            <i class="el-icon-download icon-item" @click="$_downLoadFile(item.id)"></i>
                        </mc-label>
                    </div> 
                </mc-layout-row>
                <!-- <mc-layout-row label-text="新上传附件" :labelWidth="170">
                    <el-upload action="#" :on-error="postFile" :file-list="fileList">
                    </el-upload>
                </mc-layout-row> -->
            </div>
        </div>
        <div style="padding:0 10%;">
            <el-tabs type="border-card" style="box-shadow:none">
                <el-tab-pane label="处理记录">
                    <div v-for="(item,index) in note" :key='index' style="border-bottom:1px solid #ccc;padding:10px">
                        <div class="note-info">
                            <span>{{item.user_name}}</span>
                            <span>{{$_handleTime(item.create_at)}}</span>
                        </div>
                        <div class="note-content" v-html="item.text"></div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="操作记录">
                    <div v-for="(item,index) in record" :key='index' style="border-bottom:1px solid #ccc;padding:10px">
                        <div class="note-info">
                            <span>{{item.user_name}}</span>
                            <span>{{$_handleTime(item.create_at)}}</span>
                        </div>
                        <div class="note-content" v-html="item.text"></div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <mc-dialog :dialog-option.sync="dialog.back">
            <template slot="content">
                <mc-label icon="el-icon-error" error>确定关闭工单吗？</mc-label>
                <mc-layout-row :label-show="false">
                    <el-input type="textarea" :rows="3" v-model="dialog.back.data.text" placeholder="请输入备注"></el-input>
                </mc-layout-row>
            </template>
        </mc-dialog>

    </div>
</template>

<script>
    import SparkMD5 from 'spark-md5'

    export default {
        name: "admin-edit-workList",
        data() {
            return {
                md5: '',
                formData: {
                    formTitle: '',
                    formRecord: '',
                    methodType: [{
                            label: '其他',
                            value: '1',
                        }, {
                            label: '网络',
                            value: '2',
                        },
                        {
                            label: '存储',
                            value: '3',
                        },
                        {
                            label: '服务器',
                            value: '4',
                        },
                        {
                            label: '中间件',
                            value: '5',
                        },
                        {
                            label: '数据库',
                            value: '6',
                        },
                        {
                            label: '操作系统',
                            value: '7',
                        },
                        {
                            label: '硬件故障',
                            value: '8',
                        },
                    ],
                    listType: [{
                            label: '故障处理',
                            value: '1',
                        },
                        {
                            label: '配置变更',
                            value: '2',
                        },
                        {
                            label: '配件更换',
                            value: '3',
                        },
                        {
                            label: '健康巡检',
                            value: '4',
                        },
                    ],
                },
                formValue: {
                    name: '',
                    warningContext: '',
                    methodType: '',
                    listType: '',
                },
                dialog: {
                    back: {
                        visible: false,
                        title: "提示信息",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: () => {
                                this.dialog.back.visible = true;
                            },
                            confirm: () => {
                                this.$_closeNotice();
                            }
                        },
                        data: {
                            text: "",
                        },
                    },
                },
                assignDate: {},
                id: '',
                note: [],
                record: [],
                localHost: '',
                fileList: [],
                userList: [],
                seleceItem: [],
                sort: ''
            }
        },
        mounted() {
            this.$_getInfo();
            this.$_getNote();
            this.$_getRecord();
            this.$_getUser();
            this.$_getSelectItem();
            this.sort = this.$route.params.sort;
            this.localHost = location.host;
        },
        methods: {
            $_getInfo: async function () {
                let params = {
                    id: this.$route.params.id,
                }
                let data = await this.$api.adminAssignWorkList.getList.getInfo.call(this, params);
                if (data !== false) {
                    this.assignDate = data
                    this.id = this.$route.params.id
                }
            },
            $_getNote: async function () {
                let params = {
                    id: this.$route.params.id,
                }
                let data = await this.$api.adminAssignWorkList.getList.getNotice.call(this, params);
                if (data !== false) {
                    this.note = data
                }
            },
            $_getRecord: async function () {
                let params = {
                    id: this.$route.params.id,
                }
                let data = await this.$api.adminAssignWorkList.getList.getRecord.call(this, params);
                if (data !== false) {
                    this.record = data
                    for (let item of this.record) {
                        item.text = this.$_translation(item.text)
                    }
                }
            },
            $_getUser: async function () {
                let params = {}
                let data = await this.$api.adminAssignWorkList.getList.getUser.call(this, params);
                if (data !== false) {
                    this.userList = data
                    let arr = []
                    for (let i = 0; i < this.userList.length; i++) {
                        let item = {
                            label: this.userList[i].username,
                            value: this.userList[i].user_id
                        }
                        arr.push(item)
                    }
                    this.userList = arr
                }
            },
            $_getSelectItem: async function () {
                let params = {
                    order_id: this.$route.params.id,
                }
                let data = await this.$api.adminAssignWorkList.getList.getSelectItem.call(this, params);
                if (data !== false) {
                    this.seleceItem = data
                }
            },
            $_uploadFile: async function (file) {
                let params = {
                    0: {
                        filename: file.name,
                        md5: this.md5
                    }
                }
                let data = await this.$api.adminAssignWorkList.getList.postFile.call(this, params);
                if (data !== false) {
                    this.$_getInfo();
                    this.$message.success('上传成功!')
                }
            },
            $_downLoadFile: async function (id) {
                let params = {
                    id: id,
                }
                let data = await this.$api.adminAssignWorkList.getList.downLoadFile.call(this, params);
            },
            postFile(file, fileList) {
                //这里得使用raw里面的原始file对象，不然会踩elementUI的一个坑
                let fileRaw = fileList.raw
                this.fileName = fileList.name
                // let arr = fileList.name.split('.')
                // if (arr && arr.length > 1) {
                //     let suffixName = arr[arr.length - 1].toLowerCase()
                //     if (suffixName !== 'csv') {
                //     this.$message.error('文件类型错误，请重新上传！')
                //     let index = this.fileList - 1
                //     this.fileList.splice(index, 1)
                //     return false
                //     }
                // }
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
                let fileReader = new FileReader()
                let chunkSize = 2097152
                let chunks = Math.ceil(fileList.size / chunkSize)
                let currentChunk = 0
                let spark = new SparkMD5()
                fileReader.onload = (e) => {
                    spark.append(e.target.result)
                    currentChunk++
                    if (currentChunk < chunks) {
                        loadNext()
                    } else {
                        let md5 = spark.end()
                        this.md5 = md5

                        this.$_uploadFile(fileList)
                    }
                }

                function loadNext() {
                    let start = currentChunk * chunkSize
                    let end = ((start + chunkSize) >= fileList.size) ? fileList.size : start + chunkSize
                    // 注意这里的 fileRaw
                    fileReader.readAsArrayBuffer(blobSlice.call(fileRaw, start, end))
                }
                loadNext()
                // console.log(spark.end()) 在第一次生成md5码之后再去调用 生成的码是错误的
            },
            $_closeNotice: async function () {
                let params = {
                    id: this.$route.params.id,
                    content: this.dialog.back.data.text
                }
                let data = await this.$api.adminAssignWorkList.getList.closeNotice.call(this, params);
                if (data !== false) {
                    this.$message.success('关闭成功!')
                    this.$router.go(-1)
                }
            },
            $_handleTime(item) {
                let time = Date.parse(item);
                let date = new Date(time + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
            },
            $_translation: (str) => {
                // let recordMap = {
                //     ZW00001: "变更为",
                //     ZW00002: "创建了",
                //     ZW00003: "工单",
                //     ZW00004: "添加了",
                //     ZW00005: "处理记录",
                //     ZW00006: "升级了",
                //     ZW00007: "指派了",
                //     ZW00008: "关闭了",
                //     ZW00009: "给",
                //     ZW00010: "管理员",
                //     ZW00011: "处理中",
                //     ZW00012: "升级中",
                //     ZW00013: "已关闭",
                //     ZW00014: "其他",
                //     ZW00015: "网络",
                //     ZW00016: "存储",
                //     ZW00017: "服务器",
                //     ZW00018: "中间件",
                //     ZW00019: "数据库",
                //     ZW00020: "操作系统",
                //     ZW00021: "硬件故障",
                //     ZW00022: "故障处理",
                //     ZW00023: "配置变更",
                //     ZW00024: "配件更换",
                //     ZW00025: "健康巡检",
                //     ZW00026: "重新开启",
                // };
                let recordstr = str;
                recordstr = recordstr.replace(/ZW00001/g, '变更为');
                recordstr = recordstr.replace(/ZW00002/g, '创建了');
                recordstr = recordstr.replace(/ZW00003/g, '工单');
                recordstr = recordstr.replace(/ZW00004/g, '添加了');
                recordstr = recordstr.replace(/ZW00005/g, '处理记录');
                recordstr = recordstr.replace(/ZW00006/g, '升级了');
                recordstr = recordstr.replace(/ZW00007/g, '指派了');
                recordstr = recordstr.replace(/ZW00008/g, '关闭了');
                recordstr = recordstr.replace(/ZW00009/g, '给');
                recordstr = recordstr.replace(/ZW00010/g, '管理员');
                recordstr = recordstr.replace(/ZW00011/g, '处理中');
                recordstr = recordstr.replace(/ZW00012/g, '升级中');
                recordstr = recordstr.replace(/ZW00013/g, '已关闭');
                recordstr = recordstr.replace(/ZW00014/g, '其他');
                recordstr = recordstr.replace(/ZW00015/g, '网络');
                recordstr = recordstr.replace(/ZW00016/g, '存储');
                recordstr = recordstr.replace(/ZW00017/g, '服务器');
                recordstr = recordstr.replace(/ZW00018/g, '中间件');
                recordstr = recordstr.replace(/ZW00019/g, '数据库');
                recordstr = recordstr.replace(/ZW00020/g, '操作系统');
                recordstr = recordstr.replace(/ZW00021/g, '硬件故障');
                recordstr = recordstr.replace(/ZW00022/g, '故障处理');
                recordstr = recordstr.replace(/ZW00023/g, '配置变更');
                recordstr = recordstr.replace(/ZW00024/g, '配件更换');
                recordstr = recordstr.replace(/ZW00025/g, '健康巡检');
                recordstr = recordstr.replace(/ZW00026/g, '重新开启');
                recordstr = recordstr.replace(/<ENDLINE>/g, '<br/>');
                return recordstr
            }
        }
    }
</script>

<style lang="less" scoped>
    .edit-workList {
        width: 100%;

        .form-button {
            width: 100%;
            display: inline-flex;
            justify-content: flex-end;
            padding-right: 20px;
        }

        .container {
            width: 800px;
            padding-top: 40px;
            padding-bottom: 40px;
            padding-left: 125px;

            .box-row {
                width: 100%;
                height: 60px;
                line-height: 60px;
                display: flex;

                .form-item {
                    width: 170px;
                    height: 40px;
                    margin: 10px 20px 10px;
                    padding: 0 20px;
                    line-height: 40px;
                    font-size: 14px;
                    color: #909399;
                    background-color: #f5f7fa;
                    border: 1px solid #dcdfe6;
                    border-radius: 4px;
                }
            }

            .box-row-text {
                width: 100%;
                height: auto;
                display: flex;

                .form-content {
                    width: 100%;
                    margin: 10px 0;
                }
            }

            .form-upload {
                width: 100%;
            }
        }

        .box-btn {
            margin-top: 50px;
            margin-left: 170px;
        }

        .line {
            width: 100%;
            height: 1px;
            margin: 30px 0;
            background-color: #eeeeee;
        }

        .form-item {
            width: 100%;
            display: inline-flex;
            margin-bottom: 20px;

            label {
                width: 100px;
            }

            .select-item {
                padding-right: 10px;

                span {
                    color: #1890FF;
                    cursor: pointer;
                }
            }
        }

        .note-info {
            width: 100%;
            display: inline-flex;
            justify-content: space-between;
        }

        .note-content {
            margin-bottom: 10px;
        }

        .upload-item:hover {
            color: #1890FF;
        }

        .icon-item {
            position:absolute;
            right:10px;
            cursor:pointer;
        }
    }
</style>